export var PROCESSING_RESET_PASSWORD = 'PROCESSING_NEW_PASSWORD';
export var FINISHED_RESET_PASSWORD = 'FINISHED_VERIFY_NEW_PASSWORD';
export var SET_RESET_PASSWORD_ERROR = 'SET_PASSWORD_ERROR';
export var CLEAR_RESET_PASSWORD_ERROR = 'CLEAR_RESET_PASSWORD_ERROR';
export var processingResetPassword = {
  type: PROCESSING_RESET_PASSWORD
};
export var finishedResetPassword = function finishedResetPassword(payload) {
  return {
    type: FINISHED_RESET_PASSWORD,
    payload: payload
  };
};
export var setResetPasswordError = function setResetPasswordError(payload) {
  return {
    type: SET_RESET_PASSWORD_ERROR,
    payload: payload
  };
};
export var clearResetPasswordError = function clearResetPasswordError() {
  return {
    type: CLEAR_RESET_PASSWORD_ERROR
  };
};
export var fetchResetPassword = function fetchResetPassword(payload) {
  return function (dispatch) {
    var verifycode = payload.verifycode,
      userid = payload.userid,
      d1 = payload.d1,
      password = payload.formValues.password;
    dispatch(processingResetPassword);
    var fetchUrl = atob(d1);
    var fetchPayload = {
      PendingCode: verifycode,
      Password: password,
      UserId: userid
    };
    fetch(fetchUrl + 'ResetPassword2', {
      method: 'POST',
      body: JSON.stringify(fetchPayload)
    }).then(function (response) {
      response.text().then(function (text) {
        var parsedResponse = JSON.parse(text);
        if (response.ok && parsedResponse.result) {
          return dispatch(finishedResetPassword({
            error: false,
            message:
            // context.t('You successfully reset your password. You can now login with your new password.')
            'You successfully reset your password. You can now login with your new password.'
          }));
        }
        dispatch(finishedResetPassword({
          error: true,
          message:
          // context.t('Your attempt to reset your password has failed. Contact the exchange admin if the problem persists.')
          'Your attempt to reset your password has failed. Contact the exchange admin if the problem persists.'
        }));
      });
    });
  };
};